export default __webpack_public_path__ + "static/logo-border-foods.png";